<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i><strong>Liste des campagnes</strong>
      </b-card-header>
      <b-card-body>
        <b-form-group label="Affichage des campagnes par statut">
          <b-form-checkbox-group v-model="selectedStatus">
            <b-form-checkbox value="non_commence" class="m-2">Non commencé</b-form-checkbox>
            <b-form-checkbox value="en_cours" class="m-2">En cours</b-form-checkbox>
            <b-form-checkbox value="termine" class="m-2">Terminé</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>
        <v-client-table :columns="columns" :data="data" :options="options">
          <div v-if="props.row.date_debut" slot="date_debut" slot-scope="props">
            <span class="badge badge-success p-2">{{ formatDate(props.row.date_debut) }}</span>
          </div>
          <div v-if="props.row.date_fin" slot="date_fin" slot-scope="props">
            <span class="p-2">{{ formatDate(props.row.date_fin) }}</span>
          </div>
          <div slot="action" slot-scope="props">
            <b-button type="button" @click="detailCampagne(props.row.id)" class="badge badge-primary p-2" title="détail">
              <i class="fa fa-search"></i>
            </b-button>
            <b-button type="button" v-if="statusIds.includes(props.row.statut_id)" @click.prevent="destroy(props.row)"
                      class="badge badge-danger ml-2 p-2" title="supprimer">
              <i class="fa fa-remove"></i>
            </b-button>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer">
        <b-button type="button" @click="addCampagne" class="pull-right" size="md" variant="primary">
          <i class="fa fa-plus"></i> Ajouter une campagne
        </b-button>
      </div>
    </b-card>

  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "../../../utils/auth";
  import moment from 'moment';

  export default {
    name: "GestionCampagnes",
    data() {
      return {
        selectedStatus: ['non_commence', 'en_cours'],
        columns: ['libelle', 'type_controle', 'motif_controle', 'date_debut', 'date_fin', 'statut', 'nbr_dossiers', 'action'],
        data: [],
        options: {
          headings: {
            libelle: 'Libellé',
            'type_controle': 'Type de contrôle',
            'motif_controle': "Motif de l'opération",
            date_debut: 'Date début',
            date_fin: 'Date fin',
            statut: 'Statut',
            nbr_dossiers: 'Nbre de dossier',
            action: 'Action'
          },
          sortable: ['libelle', 'date_debut'],
          filterable: ['libelle', 'motif_controle'],
          perPage: 10,
          perPageValues: [10, 25, 50],
          texts: {
            filterPlaceholder: "Libellé, motif de l'opération"
          },
          orderBy: {column: 'libelle', ascending: false}
        },
        statusIds: [],
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
      this.$axios.defaults.headers.common["Accept"] = "application/json";
      this.$axios.defaults.headers.common["Provider"] = getProvider();
      this.getStatusCampagneNonCommenceEnCours();
      this.all();
    },
    watch: {
      selectedStatus(newVal, oldVal) {
        this.selectedStatus = newVal;
        this.all();
      },
    },
    methods: {
      all() {
        const dataPost = {
          status: this.selectedStatus,
        };
        this.$axios
          .post("/espaceQualite/campagnes/list", dataPost)
          .then(response => {
            this.data = response.data.campagnes;
          })
          .catch(() => {
            this.handleErrors();
          });
      },
      destroy(campagne) {
        let html = '<div><span>Voulez-vous vraiment supprimer cette campagne ?</span><br>';
        if(campagne.nbr_dossiers_en_cours > 0) {
          html = html + '<span>Cette campagne contient '+campagne.nbr_dossiers+' dossier(s) dont '+campagne.nbr_dossiers_en_cours+ ' en cours</span>';
        }
        html = html + '</div>';
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            html: html,
            type: 'warning',
            reverseButtons: true,
            showCancelButton: true,
            cancelButtonColor: "#ff1744",
            confirmButtonText: 'Annuler',
            cancelButtonText: 'Supprimer',
          })
          .then((result) => {
            if (!result.value) {
              this.$store.commit('IS_LOADING', true);
              this.$axios
                .post("/espaceQualite/campagnes/delete/" + campagne.id)
                .then(() => {
                  this.$store.commit('IS_LOADING', false);
                  this.$swal({
                    position: 'top',
                    type: 'success',
                    title: 'Suppression avec succès',
                    text: "La campagne a bien été supprimée",
                    showConfirmButton: false,
                    timer: 5000
                  });
                  this.all();
                })
                .catch(() => {
                  this.handleErrors();
                });
            }
          })
      },
      addCampagne() {
        this.$router.push({path: '/espace-qualite/campagnes/add'})
      },
      detailCampagne(id) {
        this.$router.push({path: '/espace-qualite/campagnes/detail/' + id});
      },
      handleErrors() {
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Un problème est survenu, merci de contacter un administrateur',
          showConfirmButton: false,
          timer: 4000,
        });
      },
      getStatusCampagneNonCommenceEnCours() {
        this.$axios
          .get("/administration/status/statusCampagneNonCommenceEnCours")
          .then(response => {
            this.statusIds = response.data.data;
          })
          .catch(() => {
            this.handleErrors();
          });
      },
      formatDate(textDate) {
        return textDate !== null ? moment(textDate).format('DD/MM/YYYY') : "-";
      },
    }
  }
</script>
